import { testimonials } from "@/mocks/homeData";
import { useInView } from "@/hooks/useInView";

export default function TestimonialsSection() {
  const { ref, inView } = useInView();

  return (
    <section id="testimonials" ref={ref} className="relative py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-14 md:mb-20 ${inView ? "animate-in" : "opacity-0"}`}>
          <p className="text-secondary-600 text-xs md:text-sm font-medium tracking-widest uppercase mb-4">
            / 客户评价
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            他们怎么说
            <br />
            <span className="text-primary-600">我们</span>
          </h2>
          <p className="text-foreground-400 text-sm md:text-base mt-4 max-w-xl mx-auto">
            来自各行业客户的真实反馈，是我们最宝贵的财富
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, idx) => (
            <div
              key={item.id}
              className={`bg-background-100 rounded-2xl p-6 md:p-7 hover:bg-background-200 transition-colors duration-200 ${
                idx >= 3 ? "opacity-75 hover:opacity-100" : ""
              } ${
                inView ? `animate-in animate-in-delay-${Math.min(idx + 1, 5)}` : "opacity-0"
              }`}
            >
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-300/50">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-foreground-900 font-semibold text-sm">{item.name}</p>
                  <p className="text-foreground-400 text-xs">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}